import React from "react";
import {
  Card,
  Button,
  Typography,
  Space,
  Row,
  Col,
} from "antd";
import {
  PoweroffOutlined,
  ReloadOutlined,
  BookOutlined,
  ApiOutlined,
} from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

export default function Power() {
  return (
    <Row gutter={24}>
      {/* LEFT COLUMN */}
      <Col span={16}>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          {/* POWER */}
          <Card>
            <Title level={5}>POWER</Title>

            <Paragraph>
              <Text strong>“Power off”</Text> will do a hard shutdown of your
              server, the same as pulling a power cord. This action may cause
              data loss.
            </Paragraph>

            <Paragraph>
              <Text strong>“Shutdown”</Text> will send an ACPI signal to your
              server. If using a standard configuration, it will do a soft
              shutdown.
            </Paragraph>

            <Paragraph>
              If this does not work, this will lead to a hard shutdown of your
              server. This action may cause data loss.
            </Paragraph>

            <Paragraph type="secondary">
              Please note that we still have to bill powered-off servers. See
              Docs for details.
            </Paragraph>

            <Space>
              <Button danger type="primary" icon={<PoweroffOutlined />}>
                Power off
              </Button>
              <Button danger icon={<PoweroffOutlined />}>
                Shutdown
              </Button>
            </Space>
          </Card>

          {/* POWER RESET */}
          <Card>
            <Title level={5}>POWER RESET</Title>

            <Paragraph>
              <Text strong>“Power cycle”</Text> will issue a hard reset for your
              server. This action may cause data loss.
            </Paragraph>

            <Button danger type="primary" icon={<ReloadOutlined />}>
              Power cycle
            </Button>
          </Card>
        </Space>
      </Col>

      {/* RIGHT COLUMN */}
      <Col span={8}>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Card>
            <Title level={5}> DOCS</Title>
            <Paragraph>
              Need more information? Maybe our Docs can help.
            </Paragraph>
            <Button icon={<BookOutlined />} block>
              Go to our Docs
            </Button>
          </Card>

          <Card>
            <Title level={5}>API DOCUMENTATION</Title>
            <Paragraph>
              Check out our full-featured REST API and CLI client.
            </Paragraph>
            <Button icon={<ApiOutlined />} block>
              Go to API Docs
            </Button>
          </Card>
        </Space>
      </Col>
    </Row>
  );
}
